import { Activity, ActivityDetails } from '../../types/activities';

export const isActivityDetails = (
  type: ActivityDetails | Activity
): type is ActivityDetails => {
  return (<ActivityDetails>type).activityId !== undefined;
};
